<template>
  <div>
    <div class="mask over" @click="confirmAlert(false)"></div>
    <div class="alert-box">
      <div class="body">{{alertBody}}</div>
      <div class="foot" @click="confirmAlert(false)" v-if="type == '0'">知道了</div>
      <div class="foot col2" v-if="type == '1'">
        <span @click="confirmAlert(false)">取消</span><span @click="confirmAlert(true)">确定</span>
      </div>
      <div class="foot" @click="confirmAlert(true)" v-if="type == '2'">知道了</div>
      <div class="foot col2" v-if="type == '3'">
        <span @click="confirmAlert(false)">返回重选</span><span @click="confirmAlert(true)">不用了，谢谢</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['alertBody', 'type'],
    methods: {
      confirmAlert: function (e) {
        var param = {
          isAlert: false,
          isConfirm: e
        };
        this.$emit('open',param)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AlertBox.vue?1f6e2617